export default "__VITE_ASSET__CuWPzWQN__"